var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class CesopSubscriptions {
  /**
   * Creates an instance of CesopSubscriptions.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CesopSubscriptions
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param DisableRq_ _disableRq
   * @returns Promise<DisableRq_>
   * @memberof CesopSubscriptions
   */
  disable(pDisableRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Subscriptions/{subscriptionId}/Disable", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "subscriptionId", value: pDisableRq.subscriptionId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param EnableRq_ _enableRq
   * @returns Promise<EnableRq_>
   * @memberof CesopSubscriptions
   */
  enable(pEnableRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Subscriptions/{subscriptionId}/Enable", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "subscriptionId", value: pEnableRq.subscriptionId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
